export const filterMatchedMessages = (messages, forTypes) =>
  messages.filter((errorMessage) => forTypes.indexOf(errorMessage.type) !== -1);

export const getFilteredMessages = (forTypes, ...messages) =>
  messages.reduce((acc, cur) => [...acc, ...filterMatchedMessages(cur, forTypes)], []);
